import gql from 'graphql-tag';

import remoteItemFromProviderFragment from './remoteItemFromProviderFragment';

export const dropboxRemoteItemsPageFragment = gql`
  fragment dropboxRemoteItemsPageFragment on DropboxRemoteItemsPage {
    dokkioClass
    hasMore
    cursor
    remoteItems {
      ...remoteItemFromProviderFragment
    }
  }
  ${remoteItemFromProviderFragment}
`;
export default dropboxRemoteItemsPageFragment;
